var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen d-flex flex-column pb-17 pb-xl-0"},[_c('HeaderCompact'),_c('main',{staticClass:"flex-1"},[_c('router-view')],1),_c('NavMenuBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }